module.exports = __webpack_public_path__ + "assets/img/puhuo.391f9ac9.png";